import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { mediasActions } from '../actions/medias.actions';
import { HttpService } from '../services/http.service';
import { finalizeLoader } from '@app/shared/components';

@Injectable()
export class MediasEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getMedia$ = createEffect(() => {
        return this.actions.pipe(
            ofType(mediasActions.getMedia),
            mergeMap(({ value }) => {
                return this.httpService.getMedia(value).pipe(
                    finalizeLoader('medias-list'),
                    map(({ payload, total }) => mediasActions.getMediaSuccess({ payload, total })),
                    catchError((response: HttpErrorResponse) => of(mediasActions.getMediaError({ code: response.status }))),
                );
            }),
        );
    });
}
